import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import {
  corpKycSubmitApplication,
  getApplicationStatus,
  getApplicationStatusCorpAccount,
  submitApplication,
} from '../../../store/actions/corporateAction';
import { getContentKeyAccToLang, showToast } from '../../../utils/utils';
import { RowView, Text } from '../components';
import Button from '../../../components/Button';
import icons from '../../../constants/icons';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import { logoutUser } from '../../../store/actions/authActions';

const navItems = [
  {
    label: 'general_information',
    path: '/general-information',
    name: 'generalinformation',
  },
  {
    label: 'contact_information',
    path: '/contact-information',
    name: 'contactinformation',
  },
  {
    label: 'bank_information',
    path: '/bank-information',
    name: 'bankinformation',
  },
  {
    label: 'investment_information',
    path: '/investment-information',
    name: 'investmentportfolio',
  },
  {
    label: 'custodian_information',
    path: '/custodian-details',
    name: 'custodiandetails',
  },
  {
    label: 'client_classification',
    path: '/client-classification',
    name: 'clientclassification',
  },
  {
    label: 'signature_card',
    path: '/signature-card',
    name: 'accountoperation',
  },
  {
    label: 'tax_self_certification',
    path: '/international-tax-self-certification',
    name: 'internationtaxcertificate',
  },
  { label: 'document_vault', path: '/document-vault', name: 'documentvault', isCompleted: true },
];

const SubmitApplication = ({ setStep }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isArabic, TextWeight } = dynamicfunction();

  const { corporate } = useSelector((state) => state.content);
  const {
    corporate_loading,
    corporate_post_loading,
    application_status,
  } = useSelector((state) => state.corporate);
   const {
    client_application_id,
    is_kyc,
  } = useSelector((state) => state.constant);
  
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    if(!is_kyc){  
      await dispatch(getApplicationStatusCorpAccount(client_application_id));
    }
  }

  const handleSubmit = async () => {
    const api_data = {
      clientApplicantId: client_application_id,
    }; 
    is_kyc
      ? dispatch(
          corpKycSubmitApplication(api_data, (res) => {
            showToast({
              icon: 'success',
              title: res?.result?.responseMessage ?? '',
            });
            navigate('/funds/available-funds');
          })
        )
      : dispatch(
          submitApplication({corpClientApplicantId: client_application_id}, (res) => {
            showToast({
              icon: 'success',
              title: res?.message ?? '',
            });
            dispatch(logoutUser());
          })
        );
  };

  const getContent = (key) => {
    return getContentKeyAccToLang(
      corporate?.corporate_form_data?.data?.attributes,
      key,
      isArabic
    );
  };

  const isValid = is_kyc ? true : application_status?.every((s) => s?.isCompleted === true);
  
  return (
    <>
      {!corporate_loading && (
        <>
          <RowView isResponsive className='flex-wrap'>
            {navItems.map((item, index) => {
              const isCompleted = is_kyc ? true : (application_status?.length > 0 
                ? application_status?.find(
                    (s) =>
                      s?.sectionName?.toLowerCase() === item?.name.toLowerCase()
                  )?.isCompleted
                : false);
              return (
                <RowView
                  key={index}
                  className='gap-4 items-center w-1/2 mb-4 cursor-pointer'
                  onClick={() => setStep(index)}
                >
                  <ReactSVG
                    src={
                      isCompleted || item?.isCompleted
                        ? icons.success_icon
                        : icons?.null_icon
                    }
                  />
                  <div>
                    <Text
                      text={getContent(item?.label)}
                      className='block'
                      weight={TextWeight.medium}
                      isTruncate={false}
                    />
                    <Text
                      text={getContent('click_to_review')}
                      className='text-primary block'
                      size={fontSizes.h14}

                    />
                  </div>
                </RowView>
              );
            })}
          </RowView>

          <RowView className='mt-4'>
            <Button
              text={getContent('submit')}
              color={'text-white hover:text-primary '}
              bgColor='bg-primary hover:bg-transparent hover:border-primary'
              className={'border border-transparent w-44 px-0 text-center'}
              onClick={handleSubmit}
              isDisabled={corporate_post_loading ||  !isValid}
              loading={corporate_post_loading}
            />
          </RowView>
        </>
      )}
    </>
  );
};

export default SubmitApplication;
